// @flow
// $FlowFixMe
import React, { useMemo } from "react";
import buildColor from "@fdr/static-ui/ColorPalette";
import { isNumber } from "lodash";

import {
  RadialProgress,
  CircleIncomplete,
  CircleComplete,
  PercentageText
} from "./styled-components";

type Props = {
  width: number,
  percent: number | string,
  barColor: string,
  textColor: string,
  withTransition: boolean,
  total: number,
  isPercentage: boolean,
  index: number
};

const RadialValue = (props: Props) => {
  const {
    percent,
    width,
    barColor,
    textColor,
    withTransition,
    total,
    isPercentage,
    index
  } = props;

  const getOffset = (percentage: number | string) => {
    const r = width / 2;
    const circ = 2 * Math.PI * r;
    if (isNumber(percentage)) {
      // $FlowFixMe
      return circ - (percentage * circ) / total;
    }
    return circ;
  };

  const showPerc = (percentage: number | string) =>
    isNumber(percentage) ? `${percentage}%` : percentage;

  return useMemo(
    () => (
      <RadialProgress
        key={`${percent}-${total}-${index}`}
        viewBox="0 0 100 100"
        width={width}
      >
        <CircleIncomplete cx="50" cy="50" r={width / 2} />
        <CircleComplete
          cx="50"
          cy="50"
          r={width / 2}
          percoffset={getOffset(percent)}
          initialOffset={(width / 2) * 2 * Math.PI}
          percent={percent}
          barColor={barColor}
          withTransition={withTransition}
        />
        <PercentageText
          x="50%"
          y="55%"
          transform="matrix(0, 1, -1, 0, 100, 0)"
          textColor={textColor}
        >
          {isPercentage
            ? showPerc(percent)
            : `${
                isNumber(percent)
                  ? // $FlowFixMe
                    Math.round(percent)
                  : // $FlowFixMe
                    percent
              }
            `}
        </PercentageText>
      </RadialProgress>
    ),
    [percent, isPercentage, width]
  );
};

RadialValue.defaultProps = {
  width: 100,
  percent: 0,
  barColor: buildColor("blue", "500"),
  textColor: buildColor("grey", "900"),
  withTransition: false,
  total: 100,
  isPercentage: true,
  index: 0
};

export default RadialValue;
